import {Box, Skeleton, Tooltip} from "@mui/material";
import {StrokeHelpIcon} from "../../library";
import {TableItem} from "./components/TableItem";
import React, {useEffect, useState} from "react";
import axios from "@helpers/axios/private.axios";
import {AnalyticsWrapper} from "./index";
import {FilterByDate} from "./components/FilterByDate";

export const ByDate = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  // Функція для завантаження даних з бекенду з урахуванням фільтрів
  const getAnalytics = async (filters = {}) => {
    try {
      setLoading(true);
      // Додаємо параметри фільтрів до запиту
      const resp = await axios.get("/users/analytics/by-date", { params: filters });
      setData(resp.data.data.analytics);
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAnalytics();
  }, []);

  return (
    <AnalyticsWrapper>
      {/* >>> ДОДАЄМО КОМПОНЕНТ ФІЛЬТРІВ <<< */}
      <FilterByDate loading={loading} setLoading={setLoading} filterCallback={getAnalytics} />

      <Box sx={{overflowX: "auto"}}>
        <Box sx={{minWidth: 1100}} className="table table--mini">
          <div className="table__tr table__tr--head">
            <Box
              sx={{
                flex: "1 0 68px",
              }}
              className="table__td"
            >
              <p className="table__text">Date</p>
            </Box>
            <Box
              sx={{
                flex: "1 0 68px",
              }}
              className="table__td"
            >
              <p className="table__text">Visitors</p>
            </Box>
            <Box
              sx={{
                flex: "1 0 68px",
              }}
              className="table__td"
            >
              <p className="table__text">Registrations</p>
            </Box>
            <Box
              sx={{
                flex: "1 0 68px",
              }}
              className="table__td"
            >
              <p className="table__text">Active users</p>
            </Box>
            <Box
              sx={{
                flex: "1 0 68px",
              }}
              className="table__td"
            >
              <p className="table__text">%CTR</p>
            </Box>
            <Box
              sx={{
                flex: "1 0 67px",
              }}
              className="table__td"
            >
              <p className="table__text">
                FTD
                <Tooltip
                  title="The number of people who signed up using the link + topped up their first deposit (number of clients)"
                  placement="bottom"
                  className="tooltip__icon"
                  slotProps={{
                    tooltip: {
                      className: "tooltip__popper",
                    },
                  }}
                >
                  <i className="dashboard-full-info__help">
                    <StrokeHelpIcon/>
                  </i>
                </Tooltip>
              </p>
            </Box>
            <Box
              sx={{
                flex: "1 0 78px",
              }}
              className="table__td"
            >
              <p className="table__text">
                FTDS
                <Tooltip
                  title="Total number of first deposits per day, amount in $"
                  placement="top"
                  className="tooltip__icon"
                  slotProps={{
                    tooltip: {
                      className: "tooltip__popper",
                    },
                  }}
                >
                  <i className="dashboard-full-info__help">
                    <StrokeHelpIcon/>
                  </i>
                </Tooltip>
              </p>
            </Box>
            <Box
              sx={{
                flex: "1 0 70px",
              }}
              className="table__td"
            >
              <p className="table__text">
                DPST
                <Tooltip
                  title="The total number of deposits per day or the number of deposits of a specific client when entering a specific ID"
                  placement="bottom"
                  className="tooltip__icon"
                  slotProps={{
                    tooltip: {
                      className: "tooltip__popper",
                    },
                  }}
                >
                  <i className="dashboard-full-info__help">
                    <StrokeHelpIcon/>
                  </i>
                </Tooltip>
              </p>
            </Box>
            <Box
              sx={{
                flex: "1 0 64px",
              }}
              className="table__td"
            >
              <p className="table__text">
                DPSTS
                <Tooltip
                  title="The total amount of deposits per day or the total amount of deposits of a specific client when entering ID"
                  placement="top"
                  className="tooltip__icon"
                  slotProps={{
                    tooltip: {
                      className: "tooltip__popper",
                    },
                  }}
                >
                  <i className="dashboard-full-info__help">
                    <StrokeHelpIcon/>
                  </i>
                </Tooltip>
              </p>
            </Box>
            <Box
              sx={{
                flex: "1 0 85px",
              }}
              className="table__td"
            >
              <p className="table__text">
                RVN
                <Tooltip
                  title="Turnover - total trading turnover of referrals or a specific ID"
                  placement="top"
                  className="tooltip__icon"
                  slotProps={{
                    tooltip: {
                      className: "tooltip__popper",
                    },
                  }}
                  enterTouchDelay={0}
                >
                  <i className="dashboard-full-info__help">
                    <StrokeHelpIcon/>
                  </i>
                </Tooltip>
              </p>
            </Box>
            <Box
              sx={{
                flex: "1 0 100px",
              }}
              className="table__td"
            >
              <p className="table__text">
                RVNS
                <Tooltip
                  title="Net turnover - the same trading turnover, only with the percentage of platform profits deducted"
                  placement="top"
                  className="tooltip__icon"
                  slotProps={{
                    tooltip: {
                      className: "tooltip__popper",
                    },
                  }}
                  enterTouchDelay={0}
                >
                  <i className="dashboard-full-info__help">
                    <StrokeHelpIcon/>
                  </i>
                </Tooltip>
              </p>
            </Box>
          </div>
          {loading ? (
            <>
              <div className="table__tr">
                <Skeleton
                  className="table__skeleton"
                  variant="rounded"
                  width="100%"
                />
              </div>
              <div className="table__tr">
                <Skeleton
                  className="table__skeleton"
                  variant="rounded"
                  width="100%"
                />
              </div>
              <div className="table__tr">
                <Skeleton
                  className="table__skeleton"
                  variant="rounded"
                  width="100%"
                />
              </div>
            </>
          ) : data.length ? (
            data.map((el, index) => (
              <TableItem key={index} data={el}/>
            ))
          ) : (
            <div className="table__tr table__tr--head">
              <p>Not Found</p>
            </div>
          )}
        </Box>
      </Box>
    </AnalyticsWrapper>
  )
}